/* One delegated listener, including after theme-editor section reloads. */
(() => {
  if (window.ppProductReviewsInstalled) return;
  window.ppProductReviewsInstalled = true;
  document.addEventListener('pointerdown', () => {
    document.documentElement.classList.add('pp-reviews-pointer');
  }, {capture: true, passive: true});
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key.startsWith('Arrow')) {
      document.documentElement.classList.remove('pp-reviews-pointer');
    }
  }, true);
  function openReviews(moveFocus) {
    const widget = document.getElementById('judgeme_product_reviews');
    const topic = widget?.closest('details');
    if (!topic) return false;
    const tabs = topic.closest('pp-plant-information');
    if (tabs?.media?.matches && tabs.topics) {
      const index = tabs.topics.indexOf(topic);
      tabs.select(index);
      if (moveFocus) tabs.tabs[index].focus({preventScroll: true});
    } else {
      topic.hidden = false;
      topic.open = true;
      if (moveFocus) topic.querySelector('summary')?.focus({preventScroll: true});
    }
    requestAnimationFrame(() => {
      const target = tabs?.media?.matches ? tabs.tablist : topic;
      target.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
    return true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pp-reviews-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (openReviews(true)) event.preventDefault();
  });
  function openHash() {
    if (location.hash === '#judgeme_product_reviews') openReviews(false);
  }
  window.addEventListener('hashchange', openHash);
  if (document.readyState === 'complete') openHash();
  else window.addEventListener('load', openHash, {once: true});
})();
